<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            Поделиться
        </div>
        <div class="modal-borderline no-margin-top"></div>
        <div class="modal-data-container">
            <div class="ap-modal-element">
                <div class="design-name-input-grid">
                    <div>
                        <div class="ap-modal-input-name">
                            Ссылка
                        </div>
                        <input type="text" class="cd-modal-text-input" readonly :value="url">
                    </div>
                    <div class="gl-square-btn btn-red design-name-button" v-on:click="copyUrl()" title="Скопировать">
                        <SVGCopy class="svg-14"/>
                    </div>
                </div>
            </div>
            <div class="ap-modal-element copy-tip">
                <div v-show="isCopied">
                    Ссылка скопирована!
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SVGModalClose from "../SVG/SVGModalClose";

    import SVGCopy from "../SVG/SVGCopy";

    export default {
        name: "ModalShare",
        components: {
            SVGCopy,

            SVGModalClose
        },
        props: [
            "url"
        ],
        data() {
            return {
                isCopied: false
            }
        },
        methods: {
            copyUrl() {
                this.isCopied = false
                navigator.clipboard.writeText(this.url)
                setTimeout(() => {
                    this.isCopied = true
                }, 250)
            }
        }
    }
</script>

<style scoped>
    .btn-ok {
        width: 70px;
        text-align: center;
    }

    .design-name-input-grid {
        display: grid;
        grid-template-columns: auto max-content;
        grid-column-gap: 10px;
        margin-bottom: 20px;
    }

    .design-name-button{
        padding: 5px 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 23px;
    }

    .svg-14 {
        width: 16px;
        height: 16px;
    }

    .copy-tip {
        font-size: 14px;
        color: #939393;
        line-height: 16px;
        height: 16px;
    }
</style>
